module.exports = __webpack_public_path__ + "assets/img/27_1288.ba62ad4c.jpg";